'use client';

import { AMPLI_PLATFORM, trackAmpli } from '@modules/analytics/ampli';

const REF_MODAL = 'add_credits';

/** What the add-credits modal offered once the summary settled; `checking` is never tracked. */
export type AddCreditsModalState = 'form' | 'pending' | 'unavailable';

/** Credit funnel entry: the modal opened and settled on what it can offer. */
export function trackAddCreditsViewed(params: {
  workspaceId: string;
  modalState: AddCreditsModalState;
}) {
  trackAmpli((ampli) => {
    ampli.addCreditsViewed({
      surface: AMPLI_PLATFORM,
      ref_modal: REF_MODAL,
      workspace_id: params.workspaceId,
      modal_state: params.modalState,
    });
  });
}

export function trackCreditPackSelected(params: { workspaceId: string; credits: number }) {
  trackAmpli((ampli) => {
    ampli.creditPackSelected({
      surface: AMPLI_PLATFORM,
      ref_modal: REF_MODAL,
      workspace_id: params.workspaceId,
      credits: params.credits,
    });
  });
}
